var delivery = {

    settings : {
        checkboxes: document.querySelectorAll('.delivery__checkbox'),
        balanceSelector : '.balance',
        originalBalanceSelector : 'input[name="original-balance"]',
        currentBalanceSelector : 'input[name="current-balance"]',
        waiverBalanceSelector : 'input[name="waiver-balance"]',
        ElementsToValidate : [
            [ 'input[name="SelectedDelSchedIDX"]' ],
            [ 'input[name="UserDetails.Telephone"]' ],
            [],
            [ 'input[name="PaymentDetailsViewModel.CardDetails.CardType"]', 'input[name="PaymentDetailsViewModel.CardDetails.CardHolderName"]', 'input[name="PaymentDetailsViewModel.CardDetails.CardNumber"]', 'input[name="PaymentDetailsViewModel.CardDetails.ExpiresMonth"]', 'input[name="PaymentDetailsViewModel.CardDetails.ExpiresYear"]', 'input[name="PaymentDetailsViewModel.CardDetails.CV2"]']
        ]
    },

    Init: function() {

        // Prevents the validation from zooming to an invalid element on a different slide.
        $.validator.setDefaults({
            focusInvalid: false
        });

        this.InitCarousels();
        this.HandleResize();
        this.InitCarouselNavigation();
        this.InitDateSelector();
        this.InitValueAdds();
        this.InitSpecialRequirements();
        this.FlickityResize();

        var backupResize = setTimeout(function(){
            delivery.FlickityResize();
        }, 1500);
    },

    InitCarousels: function () {

        // Initialise the carousel
        $('.delivery-payment-carousel').each(function() {

            $thisCarousel = $(this);

            var $form = $thisCarousel.closest('form');
            var $container = $('.full-delivery-container', $form);

            var currentStep = parseInt($form.find('input[name="CurrentStep"]').val());
            var carouselIndex = currentStep - 1;
            var calendarCarouselIndex = parseInt($form.find('input[name="CalendarCarouselIndex"]').val());
            $container.attr('class', 'full-delivery-container current-step-' + currentStep);

            $thisCarousel.flickity({
                // options
                cellAlign: 'left',
                contain: true,
                freeScroll: true,
                cellSelector: '.step',
                initialIndex: carouselIndex,
                prevNextButtons: false,
                draggable: false,
                accessiblity: false
            });

            var $calendarCarousel = $thisCarousel.find('.available-dates__table-row-dates');

            var calendarCarousel = $calendarCarousel.flickity({
                // options
                cellAlign: 'left',
                contain: true,
                freeScroll: true,
                cellSelector: '.available-dates__table-table-row',
                initialIndex: calendarCarouselIndex,
                prevNextButtons: true,
                pageDots: false,
                accessiblity: false
            });

            calendarCarousel.on('cellSelect', function() {
                var flkty = $('.available-dates__table-row-dates').data('flickity');
                $firstDate = $('.available-dates__table-table-row:eq(' + flkty.selectedIndex + ')').find('.available-dates__table-table-cell:first-child');
                $lastDate = $('.available-dates__table-table-row:eq(' + flkty.selectedIndex + ')').find('.available-dates__table-table-cell:last-child');
                if ($firstDate.data('month') == $lastDate.data('month')) {
                    $('.available-dates h4').text($lastDate.data('month'));
                } else {
                  $('.available-dates h4').text($firstDate.data('month') + ' / ' + $lastDate.data('month'));
                }
            });
        });
    },

    FlickityResize: function() {
        $('.delivery-payment-carousel').flickity('resize');
        $('.available-dates__table-row-dates').flickity('resize');
    },

    HandleResize: function() {

        $('.button').on('mouseup touchend', function () {
            delivery.FlickityResize();
        });
    },

    InitCarouselNavigation: function() {

        var me = this;

        $('.carousel-step-nav button.next').on('click', function(e) {

            var $form = $(this).closest('form');
            var $carousel = $('.delivery-payment-carousel', $form);
            var $container = $('.full-delivery-container', $form);
            var validator = $form.validate();
            var flkty = $carousel.data('flickity');
            var $loader = $('.loader', $form);

            var $time = $('.order-status-time', $form);

            $('.value-add__item-selector').removeClass('show-info');
            delivery.FlickityResize();

            if (flkty.selectedIndex == 2) {
                var balance = $(delivery.settings.currentBalanceSelector, $form).val();
		        var waiverBalance = $(delivery.settings.waiverBalanceSelector, $form).val();

                if (parseFloat(balance) <= parseFloat(waiverBalance)) {
                    // Prevents validation of an empty unneeded payment screen
                    $('#step-4', $form).remove();
                    $form.submit();
                }
            }

            if(me.CheckIfValid(validator, $form.attr('id'), me.settings.ElementsToValidate[flkty.selectedIndex])) {
                // Submit form if valid and submitting payment
                if (flkty.selectedIndex == 3) {
                    $loader.show();
                    $('.button.back', $form).prop('disabled', true);
                    $(this).prop('disabled', true);
                    $form.submit();
                }

                validator.resetForm();
                $carousel.flickity().flickity('next');
                var currentStep = flkty.selectedIndex + 1;
                $container.attr('class', 'full-delivery-container current-step-' + currentStep);
                $form.find('input[name="CurrentStep"]').val(currentStep);
            }

            if ($time.visible() == false) {
                $('html, body').animate({
                    scrollTop: ($time.offset().top - 10)
                }, 300);
            }

            e.preventDefault();
            return false;
        });

        $('.carousel-step-nav button.back').on('click', function(e) {

            var $form = $(this).closest('form');
            var $carousel = $('.delivery-payment-carousel', $form);
            var $container = $('.full-delivery-container', $form);
            var validator = $form.validate();
            var flkty = $carousel.data('flickity');
            var $time = $('.order-status-time', $form);

            $('.value-add__item-selector').removeClass('show-info');
            delivery.FlickityResize();
            
            if (flkty.selectedIndex != 0) {
                $carousel.flickity().flickity('previous');
                var currentStep = flkty.selectedIndex + 1;
                $container.attr('class', 'full-delivery-container current-step-' + currentStep);
                $form.find('input[name="CurrentStep"]').val(currentStep);
            }

            if ($time.visible() == false) {
                $('html, body').animate({
                    scrollTop: ($time.offset().top - 10)
                }, 300);
            }

            e.preventDefault();
            return false;
        });
    },

    CheckIfValid: function(validator, formId, arrayOfIds) {

        var valid = true;

        if (arrayOfIds.length > 0) {

            for (var i = 0; i < arrayOfIds.length; i++) {

                var elementId = '#' + formId + ' ' + arrayOfIds[i];
                if (!validator.element(elementId)) {
                    valid = false;
                }
            }
        }

        return valid;
    },

    InitSpecialRequirements: function() {

        $('input[type=radio][name=SpecialRequirements]').on('change', function() {

            var $form = $(this).closest('form');

            if ($(this).val() == "true")
            {
                $('.special-requirements .form__input--textarea-toggle', $form).show(100,function(){
                    delivery.FlickityResize();
                });
            }
            else
            {
                $('.special-requirements .form__input--textarea-toggle', $form).hide(100, function(){
                    delivery.FlickityResize();
                });
            }
        });
    },

    InitDateSelector: function() {

        // Update selected date on final screen
        // Current selected, if any
        var $selectedDate = $('input[name="SelectedDelSchedIDX"]:checked');
        if ($selectedDate.size() > 0) {
            var $form = $selectedDate.closest('form');
            delivery.CalculateTotal($form);
        }

        $('input[type=radio][name=SelectedDelSchedIDX]').on('change', function() {
            var $form = $(this).closest('form');
            delivery.CalculateTotal($form);
        });
    },

    InitValueAdds: function() {

        $('input[type=checkbox].delivery__checkbox').on('change', function() {
            var $form = $(this).closest('form');
            delivery.CalculateTotal($form);
        });

        $('.value-add__info-toggle').on('click', function() {
            $(this).closest('.value-add__item-selector').toggleClass('show-info');
            delivery.FlickityResize();
        });
    },

    CalculateTotal : function(context) {

        var originalBalance = parseFloat($(delivery.settings.originalBalanceSelector, context).val());
        var currentBalance = parseFloat($(delivery.settings.currentBalanceSelector, context).val());

        // Delivery surcharge

        // Current selected, if any
        $selectedDate = $('input[name="SelectedDelSchedIDX"]:checked', context);
        var deliverySurcharge = ($selectedDate.size() > 0) ? $selectedDate.data('amount') : 0;
        var newbalance = originalBalance + parseFloat(deliverySurcharge);

        // Update selected date on final screen
        if ($selectedDate.size() > 0) {
            $('.final-summary span', context).text($selectedDate.data('date'));
        }

        // Value Add Items
        $('.delivery__checkbox').each(function() {
            var $checkbox = $(this);
            if ($checkbox.is(':checked')) {
                var itemAmount = (parseFloat($checkbox.data('amount')) * parseInt($checkbox.data('quantity')));
                newbalance += parseFloat(itemAmount);
            }
        });

        // Update Balance
        if (newbalance != currentBalance)
        {
            delivery.UpdateBalance(newbalance, context);
        }
    },

    UpdateBalance: function(balance, context) {

        var waiverBalance = parseFloat($(delivery.settings.waiverBalanceSelector, context).val());

        $('#submit-step-3-button', context).text((parseFloat(balance) <= parseFloat(waiverBalance)) ? 'Complete Booking' : 'Pay Balance');

        $(delivery.settings.balanceSelector, context).text(balance.toFixed(2));
        $(delivery.settings.currentBalanceSelector, context).val(balance.toFixed(2));
    }
};

(function () {
    delivery.Init();
})();
